import { render } from "./DashboardSection.vue?vue&type=template&id=a720c82e"
import script from "./DashboardSection.vue?vue&type=script&lang=js"
export * from "./DashboardSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__